import * as React from 'react'
import styled from 'styled-components'
import { IdCtx } from './context'
import { Modals } from './use-modals'

const ModalRootWrapper = styled.div`
  position: relative;
  z-index: 1001;
`

export const ModalRoot = () => {
  const store = Modals.use()

  return (
    <ModalRootWrapper>
      {store.modals.map((x) => (
        <IdCtx.Provider key={x.id} value={x.id}>
          {x.e}
        </IdCtx.Provider>
      ))}
    </ModalRootWrapper>
  )
}
